import Cart from "../../home/components/cart";
import Layout from "../../../components/layout";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMoneyBill1,
  faMotorcycle,
  faLocationDot,
  faCircleNotch,
  faPlus,
  faArrowRight,
  faInfoCircle,
} from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { useCallback, useEffect, useRef, useState } from "react";
import { API_BASE_URL } from "../../../utils/useFetch";
import OrderSuccessModal from "./components/orderSuccessModal";
import { toast } from "react-hot-toast";
import { IFood } from "../../../components/foodCard/food.interface";
import AddAddressModal from "../../profile/addresses/components/addAddressModal";
import { clearCart } from "../../../redux/slices/basketSlice";
import { useNavigate } from "react-router-dom";

const Checkout = () => {
  const navigate = useNavigate();

  const userData = useSelector((state: RootState) => state.user.userInfo);
  const appSettings = useSelector((state: RootState) => state.app.appSettings);

  const basket = useSelector((state: RootState) => state.basket);
  const [deliveryCost, setDeliveryCost] = useState(0);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [orderNumber, setOrderNumber] = useState("0");
  const [addresses, setAddresses] = useState<any[]>([]);
  const [selectedAddress, setSelectedAddress] = useState("0");
  const [selectedDelivery, setSelectedDelivery] = useState("0");
  const [selectedPayment, setSelectedPayment] = useState(
    appSettings.online_shop === "1" ? "3" : "2"
  );
  const [isSendingData, setIsSendingData] = useState(false);
  const [addAddressModalShow, setAddAddressModalShow] = useState(false);
  const [PGToken, setPGToken] = useState("");
  const PGForm = useRef<HTMLFormElement>(null);
  const dispatch = useDispatch();
  const fetchAddresses = useCallback(async () => {
    const _formData = new FormData();
    _formData.append("mobile", userData.mobile);
    _formData.append("code", userData.code);
    const response = await fetch(API_BASE_URL + "v2/get_addresses", {
      method: "POST",
      body: _formData,
    });
    return response.json();
  }, [userData]);

  useEffect(() => {
    setSelectedDelivery(appSettings.location_delivery === 1 ? "1" : "0");
    setSelectedPayment(appSettings.online_shop === "1" ? "3" : "2");
  }, [appSettings]);

  useEffect(() => {
    if (selectedDelivery === "0") {
      setDeliveryCost(0);
    } else {
      fetchAddresses().then((response) => {
        setAddresses(response);
        setDeliveryCost(response[0].cost);
        setSelectedAddress(response[0].id);
      });
    }
  }, [fetchAddresses, selectedDelivery, addAddressModalShow]);

  useEffect(() => {
    const selectedAdrs = addresses.find(
      (adrs) => adrs.id + "" === selectedAddress
    );
    if (selectedAdrs) {
      setDeliveryCost(selectedAdrs.cost);
    }
  }, [selectedAddress, addresses]);

  const fetchSubmitOrder = useCallback(async (fullOrder: any) => {
    const _formData = new FormData();
    _formData.append("mobile", fullOrder.phone);
    _formData.append("code", fullOrder.code);
    _formData.append("deliverType", fullOrder.deliveryType);
    _formData.append("payMethod", fullOrder.payType);
    _formData.append(
      "addressId",
      fullOrder.deliveryType === "0" ? "0" : fullOrder.address
    );
    _formData.append("isfromweb", "1");
    for (let i = 0; i < fullOrder.products.length; i++) {
      _formData.append("mealsIds[]", fullOrder.products[i].id);
      _formData.append("mealsCount[]", fullOrder.products[i].count);
    }

    const response = await fetch(API_BASE_URL + "newsubmitorder", {
      method: "POST",
      body: _formData,
    });

    return response.json();
  }, []);

  const handleSubmitOrder = () => {
    if (selectedDelivery === "1" && selectedAddress === "0") {
      toast.error("لطفا آدرس خود را انتخاب کنید");
      return;
    }

    if (selectedDelivery === "1" && selectedAddress !== "0") {
      let selectedAddressDelivery = addresses.find(
        (adrs) => adrs.id === parseInt(selectedAddress)
      );
      if (selectedAddressDelivery.region_status === 0) {
        toast.error(
          " متاسفانه منطقه آدرس انتخابی شما خارج از محدوده سرویس پیک است. لطفا آدرس دیگری را انتاخب کنید "
        );
        return;
      }
    }

    if (selectedPayment === "2" && appSettings.pos_shop === "0") {
      toast.error("لطفا روش پرداخت خود را انتخاب کنید");
      return;
    }

    setIsSendingData(true);

    const orderFoods = basket.cart.map((food: IFood) => {
      return { id: food.id, count: food.quantity };
    });

    const fullOrder = {
      code: userData.code,
      phone: userData.mobile,
      payType: selectedPayment,
      deliveryType: selectedDelivery,
      address: selectedAddress,
      products: orderFoods,
      isfromweb: 1,
    };

    fetchSubmitOrder(fullOrder)
      .then((response) => {
        if (response.toString() === "-1") {
          toast.error("امکان ثبت سفارش وجود ندارد");
        } else if (response.state === "fail") {
          toast.error(response.message + " gertY");
        } else if (response.toString() !== "-1") {
          if (selectedPayment === "3") {
            setPGToken(response.token);

            if (typeof window.Android === "undefined") {
              window.location.replace(
                "https://app.tiarafood.ir/redirect_pay?token=" + response.token
              );
            } else {
              window.Android.openExternalBrowser(
                "https://app.tiarafood.ir/redirect_pay?token=" + response.token
              );
            }

            dispatch(clearCart());
          } else {
            setOrderNumber(response.orderCode.toString());
            dispatch(clearCart());
            setShowSuccessModal(true);
          }
        } else {
          toast.error(response.toString() + " gertY");
        }
        setIsSendingData(false);
      })
      .catch((error) => {
        setIsSendingData(false);
        toast.error(error.toString());
      });
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <Layout>
      <section className='container mx-auto lg:flex mt-2 '>
        <div className='lg:hidden mb-4'>
          <Cart
            isFromCheckoutPage={true}
            deliveryCost={deliveryCost}
          />
        </div>

        <form
          method='post'
          className='hidden'
          ref={PGForm}
          action='https://sep.shaparak.ir/OnlinePG/OnlinePG'
        >
          <input
            type='hidden'
            name='Token'
            value={PGToken}
          />
          <input
            type='texx'
            name='GetMethod'
            value=''
          />
        </form>

        <div className='lg:flex-1 border lg:ml-8 bg-white'>
          <div className='p-2 font-bold border-b border-solid'>
            نحوه تحویل سفارش
          </div>

          <div className='pt-4 pr-4 lg:hidden'>
            <FontAwesomeIcon icon={faMotorcycle} /> روش تحویل
          </div>
          <div className='p-4 border-b flex'>
            <div className='w-40 hidden lg:block'>
              <FontAwesomeIcon icon={faMotorcycle} /> روش تحویل
            </div>
            <div className='flex-1'>
              {appSettings.location_delivery === 1 && (
                <div className='flex items-center mb-4'>
                  <input
                    id='delivery-method-1'
                    type='radio'
                    value='1'
                    name='delivery-method'
                    checked={selectedDelivery === "1"}
                    onChange={(e) => setSelectedDelivery(e.target.value)}
                    className='w-4 h-4 text-rose-900 bg-gray-100 border-gray-300 '
                  />
                  <label
                    htmlFor='delivery-method-1'
                    className='mr-2'
                  >
                    <div className='font-bold text-rose-900'>تحویل در محل </div>
                    <div>توسط پیک ارسال می شود</div>
                    {deliveryCost > 0 && (
                      <div>
                        هزینه :{" "}
                        {new Intl.NumberFormat("fa-IR").format(deliveryCost)}{" "}
                        ریال
                      </div>
                    )}
                  </label>
                </div>
              )}

              <div className='flex items-center'>
                <input
                  id='delivery-method-2'
                  type='radio'
                  value='0'
                  name='delivery-method'
                  checked={selectedDelivery === "0"}
                  onChange={(e) => {
                    console.log("e.target.value", e.target.value);
                    setSelectedDelivery(e.target.value);
                  }}
                  className='w-4 h-4 text-brose-900 bg-gray-100 border-gray-300 '
                />
                <label
                  htmlFor='delivery-method-2'
                  className='mr-2'
                >
                  <div className='font-bold text-rose-900'>
                    تحویل در رستوران
                  </div>
                  <div>تحویل حضوری در محل رستوران</div>
                </label>
              </div>
            </div>
          </div>

          <div
            className={`${
              selectedDelivery === "0" && "hidden"
            }  pt-4 pr-4 lg:hidden `}
          >
            <FontAwesomeIcon icon={faLocationDot} /> آدرس تحویل
          </div>
          <div
            className={`${
              selectedDelivery === "0" ? "hidden" : "flex"
            }  pt-4 pr-4 border-b `}
          >
            <div className='w-40 hidden lg:block'>
              <FontAwesomeIcon icon={faLocationDot} /> آدرس تحویل
            </div>

            <div className='flex-1'>
              {addresses.map((address, index) => (
                <div className='flex mb-4 items-center'>
                  <input
                    id={`addresses-${address.id}`}
                    type='radio'
                    value={address.id}
                    name='addresses'
                    disabled={address.region_status !== 1}
                    checked={parseInt(selectedAddress) === parseInt(address.id)}
                    onChange={(e) => setSelectedAddress(e.target.value)}
                    className='w-4 h-4 text-rose-900 bg-gray-100 border-gray-300'
                  />
                  <label
                    htmlFor={`addresses-${address.id}`}
                    className='mr-2'
                  >
                    {address.region_status !== 1 && (
                      <div>
                        <span
                          className={`inline-block font-normal whitespace-nowrap rounded px-[0.5em] pt-[0.35em] pb-[0.25em] text-center align-baseline text-[0.75em] leading-none text-rose-500 bg-rose-100 mr-1`}
                        >
                          <FontAwesomeIcon icon={faInfoCircle} /> اکنون این
                          منطقه خارج از محدوده ارسال است
                        </span>
                      </div>
                    )}

                    <div>
                      <div className='font-bold'>
                        {address.region}
                        <span
                          className={`inline-block font-normal whitespace-nowrap rounded px-[0.5em] pt-[0.35em] pb-[0.25em] text-center align-baseline text-[0.75em] leading-none text-gray-500 bg-gray-100 mr-1`}
                        >
                          <FontAwesomeIcon icon={faMotorcycle} />{" "}
                          {new Intl.NumberFormat("fa-IR").format(address.cost)}{" "}
                          ریال
                        </span>
                      </div>

                      <div>{address.address}</div>
                    </div>
                  </label>
                </div>
              ))}
              <button
                className='border rounded border-rose-900 px-2 py-1 my-4 text-rose-900'
                onClick={() => setAddAddressModalShow((prev) => !prev)}
              >
                <FontAwesomeIcon
                  icon={faPlus}
                  className='ml-1'
                />
                افزودن آدرس
              </button>
            </div>
          </div>
          {/* 
          <div className='pt-4 pr-4 lg:hidden'>
            <FontAwesomeIcon icon={faStickyNote} /> توضیحات سفارش
          </div>

          <div className='p-4 border-b flex'>
            <div className='w-40 hidden lg:block'>
              <FontAwesomeIcon icon={faStickyNote} /> توضیحات سفارش
            </div>
            <div className='flex-1'>
              <textarea
                rows={3}
                className='border rounded w-full'
              />
            </div>
          </div> */}

          <div className='pt-4 pr-4 lg:hidden'>
            <FontAwesomeIcon icon={faMoneyBill1} /> روش پرداخت
          </div>
          <div className='p-4 border-b flex'>
            <div className='w-40 hidden lg:block'>
              <FontAwesomeIcon icon={faMoneyBill1} /> روش پرداخت
            </div>
            <div className='flex-1'>
              {appSettings.online_shop === "1" && (
                <div className='flex items-center mb-4'>
                  <input
                    id='pay-method-3'
                    type='radio'
                    value='3'
                    defaultChecked={appSettings.online_shop === "1"}
                    name='pay-method'
                    onChange={(e) => setSelectedPayment(e.target.value)}
                    className='w-4 h-4 text-rose-900 bg-gray-100 border-gray-300 '
                  />
                  <label
                    htmlFor='pay-method-3'
                    className='mr-2'
                  >
                    <div className='font-bold text-rose-900'>
                      پرداخت اینترنتی
                      <span
                        className={`inline-block font-normal whitespace-nowrap rounded px-[0.5em] pt-[0.35em] pb-[0.25em] text-center align-baseline text-[0.75em] leading-none text-rose-500 bg-rose-100 mr-1`}
                      >
                        <FontAwesomeIcon icon={faInfoCircle} />
                        لطفا از خاموش بودن فیلتر شکن خود مطمئن شوید
                      </span>
                      ‍‍
                    </div>
                  </label>
                </div>
              )}

              {appSettings.pos_shop === "1" && (
                <div className='flex items-center mb-4'>
                  <input
                    id='pay-method-2'
                    type='radio'
                    defaultChecked={
                      appSettings.pos_shop === "1" &&
                      appSettings.online_shop !== "1"
                    }
                    value='2'
                    name='pay-method'
                    onChange={(e) => setSelectedPayment(e.target.value)}
                    className='w-4 h-4 text-rose-900 bg-gray-100 border-gray-300 '
                  />
                  <label
                    htmlFor='pay-method-2'
                    className='mr-2'
                  >
                    <div className='font-bold text-rose-900'>
                      کارتخوان در محل تحویل
                    </div>
                  </label>
                </div>
              )}
              {appSettings.pos_shop === "1" && (
                <div className='flex items-center'>
                  <input
                    id='pay-method-1'
                    type='radio'
                    value='1'
                    name='pay-method'
                    onChange={(e) => setSelectedPayment(e.target.value)}
                    className='w-4 h-4 text-brose-900 bg-gray-100 border-gray-300 '
                  />
                  <label
                    htmlFor='pay-method-1'
                    className='mr-2'
                  >
                    <div className='font-bold text-rose-900'>
                      نقدی در محل تحویل
                    </div>
                  </label>
                </div>
              )}
            </div>
          </div>

          <div className='p-4'>
            <button
              className=' bg-rose-900 text-white p-4 rounded w-full'
              onClick={handleSubmitOrder}
            >
              {isSendingData ? (
                <>
                  <FontAwesomeIcon
                    icon={faCircleNotch}
                    className='rotate-animation'
                  />
                  {selectedPayment === "3" && "درحال اتصال به درگاه بانکی"}
                </>
              ) : (
                <>ثبت سفارش</>
              )}
            </button>

            <div
              className={`${
                basket.cart.length === 0 && "hidden"
              } text-rose-900 cursor-pointer p-2 text-center font-bold border rounded border-rose-900 mt-2`}
              onClick={() => navigate("/", { replace: true })}
            >
              <FontAwesomeIcon icon={faArrowRight} /> بازگشت به منوی سفارش
            </div>
          </div>
        </div>
        <div className='lg:w-80 hidden lg:block'>
          <Cart
            isFromCheckoutPage={true}
            deliveryCost={deliveryCost}
          />
        </div>
      </section>
      {showSuccessModal && (
        <OrderSuccessModal
          orderNumber={orderNumber}
          handleModal={() => setShowSuccessModal((prev) => !prev)}
        />
      )}

      {addAddressModalShow && (
        <AddAddressModal
          showModal={() => setAddAddressModalShow((prev) => !prev)}
        />
      )}
    </Layout>
  );
};

export default Checkout;
